<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg3 md4 sm6 xs12>
          <v-menu
            v-model="menuMonth"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="computedMonthFormatted"
                label="Tháng báo cáo"
                hint="YYYY-MM"
                persistent-hint
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="selectedMonth"
              type="month"
              no-title
              @input="menuMonth = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex lg4 md6 sm12 xs12>
          <v-select
            v-model="selectedChartMetrics"
            :items="chartMetricOptions"
            label="Chỉ số hiển thị biểu đồ"
            item-text="text"
            item-value="value"
            multiple
            chips
            deletable-chips
          ></v-select>
        </v-flex>
        <v-flex lg2 md4 sm6 xs12 class="d-flex align-end" pb-5>
          <v-btn @click="filter_data" color="#a41c21" outlined class="mr-2">Xem</v-btn>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex lg12 v-if="items && items.length > 0">
          <v-card class="mb-4">
            <v-card-title>Biểu đồ hoa hồng sale</v-card-title>
            <v-card-text>
              <highcharts :options="chartOptions"></highcharts>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex lg12 v-if="items">
          <v-data-table
            hide-default-footer
            :headers="headers"
            :items="items"
            :server-items-length="items.length"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.SaleName }}</td>
                <td class="text-end">{{ item.TotalBills | currency }}</td>
                <td class="text-end">{{ item.TotalPack | currency }}</td>
                <td class="text-end">{{ item.TotalWeight | currency('', 1) }}</td>
                <td class="text-end">{{ item.TotalVolume | currency('', 2) }}</td>
                <td class="text-end">{{ item.Revenue | currency }}</td>
                <td class="text-end">{{ item.ShippingFee | currency }}</td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.CommissionRate"
                    @save="onSaveCommissionRate(item, $event)"
                    save-text="Lưu"
                    cancel-text="Hủy"
                  >
                    <v-chip small color="primary" outlined>{{ item.CommissionRate }}%</v-chip>
                    <template v-slot:input>
                      <v-text-field
                        v-model.number="item.CommissionRate"
                        label="Tỷ lệ thưởng (%)"
                        type="number"
                        step="0.1"
                        min="0"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">{{ item.BonusMultiplier }}</td>
                <td class="text-end green--text">{{ item.RevenueBonus | currency }}</td>
                <td class="text-end orange--text">{{ item.MarginBonus | currency }}</td>
                <td class="text-end font-weight-bold red--text">{{ item.Commission | currency }}</td>
              </tr>
            </template>
            <template v-slot:[`body.append`]>
              <tr class="font-weight-bold">
                <td>TỔNG</td>
                <td class="text-end">{{ dic_summary.TotalBills | currency }}</td>
                <td class="text-end">{{ dic_summary.TotalPack | currency }}</td>
                <td class="text-end">{{ dic_summary.TotalWeight | currency('', 1) }}</td>
                <td class="text-end">{{ dic_summary.TotalVolume | currency('', 2) }}</td>
                <td class="text-end">{{ dic_summary.Revenue | currency }}</td>
                <td class="text-end">{{ dic_summary.ShippingFee | currency }}</td>
                <td></td><td></td>
                <td class="text-end green--text">{{ dic_summary.RevenueBonus | currency }}</td>
                <td class="text-end orange--text">{{ dic_summary.MarginBonus | currency }}</td>
                <td class="text-end red--text">{{ dic_summary.Commission | currency }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import moment from "moment";

export default {
  name: "bao-cao-hoa-hong-sale",
  data() {
    return {
      selectedMonth: moment().format("YYYY-MM"),
      selectedChartMetrics: ["TotalPack", "Revenue", "Commission"],
      menuMonth: false
    };
  },
  computed: {
    ...mapState({
      items: state => (state.report.saleCommissions && state.report.saleCommissions.data) ? state.report.saleCommissions.data : [],
      reportTiers: state => (state.report.saleCommissions && state.report.saleCommissions.summary && state.report.saleCommissions.summary.tiers) ? state.report.saleCommissions.summary.tiers : [],
      configTiers: state => state.saleCommissionConfig.tiers || [],
      loading: state => state.report.loading
    }),
    computedMonthFormatted() {
      return this.selectedMonth;
    },
    chartMetricOptions() {
      return [
        { text: "Tổng kiện",       value: "TotalPack" },
        { text: "Tổng cân",         value: "TotalWeight" },
        { text: "Tổng khối",        value: "TotalVolume" },
        { text: "Doanh thu",        value: "Revenue" },
        { text: "Tiền vận chuyển",  value: "ShippingFee" },
        { text: "Thưởng doanh số",        value: "RevenueBonus" },
        { text: "Thưởng chênh lệch",        value: "MarginBonus" },
        { text: "Hoa hồng",         value: "Commission" }
      ];
    },
    dic_summary() {
      return {
        TotalBills:   _.sumBy(this.items, "TotalBills"),
        TotalPack:    _.sumBy(this.items, "TotalPack"),
        TotalWeight:  _.sumBy(this.items, "TotalWeight"),
        TotalVolume:  _.sumBy(this.items, "TotalVolume"),
        Revenue:      _.sumBy(this.items, "Revenue"),
        ShippingFee:  _.sumBy(this.items, "ShippingFee"),
        RevenueBonus: _.sumBy(this.items, "RevenueBonus"),
        MarginBonus:  _.sumBy(this.items, "MarginBonus"),
        Commission:   _.sumBy(this.items, "Commission")
      };
    },
    headers() {
      return [
        { text: "Nhân viên sale",      value: "SaleName",        filterable: true },
        { text: "Số phiếu đã TT",      value: "TotalBills",      align: "end" },
        { text: "Tổng kiện",           value: "TotalPack",        align: "end" },
        { text: "Tổng cân",            value: "TotalWeight",      align: "end" },
        { text: "Tổng khối",           value: "TotalVolume",      align: "end" },
        { text: "Doanh Thu",           value: "Revenue",          align: "end" },
        { text: "Tiền vận chuyển",     value: "ShippingFee",      align: "end" },
        { text: "Tỷ lệ thưởng",        value: "CommissionRate",   align: "end" },
        { text: "Hệ số",              value: "BonusMultiplier",  align: "end" },
        { text: "Thưởng doanh số",    value: "RevenueBonus",     align: "end" },
        { text: "Thưởng chênh lệch",  value: "MarginBonus",      align: "end" },
        { text: "Tổng hoa hồng", value: "Commission",      align: "end" }
      ];
    },
    filter_params() {
      const monthStart = moment(this.selectedMonth, "YYYY-MM").startOf("month");
      const monthEnd = moment(this.selectedMonth, "YYYY-MM").endOf("month");
      return {
        startTime: monthStart.format(configs.SQL_DATE_FORMAT),
        endTime: monthEnd.format(configs.SQL_DATE_FORMAT)
      };
    },
    chartOptions() {
      if (!this.items || this.items.length === 0) {
        return {};
      }

      const categories = this.items.map(item => item.SaleName || "-");
      const metricConfig = {
        TotalPack: {
          name: "Tổng kiện",
          color: "#FF9800",
          yAxis: 0
        },
        TotalWeight: {
          name: "Tổng cân",
          color: "#9C27B0",
          yAxis: 0
        },
        TotalVolume: {
          name: "Tổng khối",
          color: "#00ACC1",
          yAxis: 0
        },
        Revenue: {
          name: "Doanh Thu",
          color: "#2196F3",
          yAxis: 1
        },
        ShippingFee: {
          name: "Tiền vận chuyển",
          color: "#795548",
          yAxis: 1
        },
        Commission: {
          name: "Hoa hồng",
          color: "#E91E63",
          yAxis: 1
        },
        RevenueBonus: {
          name: "Thưởng doanh số",
          color: "#4CAF50",
          yAxis: 1
        },
        MarginBonus: {
          name: "Thưởng chênh lệch",
          color: "#FF5722",
          yAxis: 1
        }
      };

      const selectedMetrics = this.selectedChartMetrics && this.selectedChartMetrics.length > 0
        ? this.selectedChartMetrics
        : ["Commission"];

      const series = selectedMetrics.map(metric => ({
        name: metricConfig[metric].name,
        data: this.items.map(item => Number(item[metric]) || 0),
        color: metricConfig[metric].color,
        yAxis: metricConfig[metric].yAxis
      }));

      return {
        chart: {
          type: "column",
          height: 400
        },
        title: {
          text: ""
        },
        xAxis: {
          categories: categories
        },
        yAxis: [
          {
            min: 0,
            title: {
              text: "Số lượng"
            }
          },
          {
            min: 0,
            title: {
              text: "Số tiền (VNĐ)"
            },
            opposite: true
          }
        ],
        tooltip: {
          shared: true,
          useHTML: true,
          formatter: function() {
            let s = "<b>" + this.x + "</b><br/>";
            this.points.forEach(point => {
              s +=
                '<span style="color:' +
                point.color +
                '">●</span> ' +
                point.series.name +
                ": <b>" +
                point.y.toLocaleString("vi-VN") +
                " VNĐ</b><br/>";
            });
            return s;
          }
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: series,
        credits: {
          enabled: false
        }
      };
    }
  },
  methods: {
    filter_data() {
      this.$store.dispatch("report/getSaleCommissionReport", this.filter_params);
    },
    async onSaveCommissionRate(item, value) {
      const normalizedRate = Number(value !== undefined ? value : item.CommissionRate || 0);
      const multiplier = Number(item.BonusMultiplier || 1);
      const revenue = Number(item.Revenue || 0);
      item.CommissionRate = normalizedRate;
      item.RevenueBonus = Math.round(revenue * (normalizedRate / 100) * multiplier);
      item.Commission = Math.round(Number(item.RevenueBonus || 0) + Number(item.MarginBonus || 0));
      item.TierName = "Tùy chỉnh";

      let tiers = this.reportTiers && this.reportTiers.length > 0 ? this.reportTiers : this.configTiers;
      if (!tiers || tiers.length === 0) {
        await this.$store.dispatch("saleCommissionConfig/getTiers");
        tiers = this.configTiers || [];
      }

      let tierId = item.TierID;
      let tier = _.find(tiers, t => Number(t.ID) === Number(tierId));
      if (!tier) {
        tier = _.find(tiers, t => {
          const minRev = Number(t.MinRevenue || 0);
          const maxRev = t.MaxRevenue === null || t.MaxRevenue === '' ? null : Number(t.MaxRevenue);
          return revenue >= minRev && (maxRev === null || revenue < maxRev);
        });
        tierId = tier ? tier.ID : null;
      }

      if (!tierId || !tier) {
        this.$root.$emit("REQUEST_SNACKBAR", {
          message: "Không xác định được bậc thưởng để lưu",
          color: "warning"
        });
        return;
      }

      const payload = {
        ...tier,
        CommissionRate: normalizedRate
      };

      this.$store.dispatch("saleCommissionConfig/saveTier", {
        tier: payload,
        pk: tierId
      }).then(() => {
        this.$root.$emit("REQUEST_SNACKBAR", {
          message: "Đã lưu tỷ lệ thưởng vào cấu hình hệ thống",
          color: "success"
        });
      }).catch((err) => {
        const msg = err && err.body && err.body.reason
          ? err.body.reason
          : "Lưu tỷ lệ thưởng thất bại";
        this.$root.$emit("REQUEST_SNACKBAR", {
          message: msg,
          color: "error"
        });
      });
    },
    exportData() {
      this.$store.dispatch("report/exportSaleCommissionList", this.filter_params);
    }
  },
  mounted() {
    this.filter_data();
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("REQUEST_EXPORT_ACTION", this.exportData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("REQUEST_EXPORT_ACTION", this.exportData);
  }
};
</script>
